(() => {
  'use strict';

  const READY_FLAG = 'kbComparisonsReady';
  // The block can appear several times, so the file may be requested twice.
  if (document.documentElement.dataset[READY_FLAG]) return;
  document.documentElement.dataset[READY_FLAG] = 'true';

  const ROOT_SELECTOR = '[data-kb-comparisons]';
  const TRACK_SELECTOR = '[data-kb-comparisons-track]';
  const PREV_SELECTOR = '[data-kb-comparisons-prev]';
  const NEXT_SELECTOR = '[data-kb-comparisons-next]';
  const SLIDE_SELECTOR = '.kalaboost-tab-comparison';
  const EDGE_TOLERANCE = 2;

  function step(track) {
    const slide = track.querySelector(SLIDE_SELECTOR);
    if (!slide) return track.clientWidth;

    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function refresh(root) {
    const track = root.querySelector(TRACK_SELECTOR);
    const previous = root.querySelector(PREV_SELECTOR);
    const next = root.querySelector(NEXT_SELECTOR);
    if (!track) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const scrollable = maxScroll > EDGE_TOLERANCE;

    if (previous) previous.hidden = !scrollable || track.scrollLeft <= EDGE_TOLERANCE;
    if (next) next.hidden = !scrollable || track.scrollLeft >= maxScroll - EDGE_TOLERANCE;
  }

  function observe(root) {
    const track = root.querySelector(TRACK_SELECTOR);
    if (!track) return;

    track.addEventListener('scroll', () => refresh(root), { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(() => refresh(root)).observe(track);
    }

    refresh(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(observe);
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const control = event.target.closest(`${PREV_SELECTOR}, ${NEXT_SELECTOR}`);
    if (!control) return;

    const root = control.closest(ROOT_SELECTOR);
    const track = root?.querySelector(TRACK_SELECTOR);
    if (!track) return;

    const direction = control.matches(PREV_SELECTOR) ? -1 : 1;
    track.scrollBy({ left: step(track) * direction, behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
